import { productCategoryApi } from "apis";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { ProductCategoryRequestBodyType } from "constants/types/productCategory";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/ProductCategory/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import ProductCategoryFormFields from "../ProductCategoryFormFields/ProductCategoryFormFields";
import { createValidationSchema } from "./config";

type Props = {
  onClose?: () => void;
  mutate?: () => void;
};

const CreateForm: FC<Props> = ({ onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik<ProductCategoryRequestBodyType>({
    initialValues: {
      code: "",
      name: "",
    },
    validationSchema: createValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await productCategoryApi.create(values);
        notification.success({ title: "Tạo nhóm mặt hàng thành công" });
        onClose?.();
        mutate?.();
        formik.resetForm();
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title: "Tạo nhóm mặt hàng thất bại",
          message: error?.error?.message,
        });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <form id={FORM_IDS.CREATE} onSubmit={formik.handleSubmit}>
        <ProductCategoryFormFields formik={formik} />
      </form>
    </Loading>
  );
};

export default CreateForm;
